module.exports = __webpack_public_path__ + "img/callisto-2.40dbe626.png";